import { render, staticRenderFns } from "./addSchemaAcquiringSettings.vue?vue&type=template&id=a3ab2fb2"
import script from "./addSchemaAcquiringSettings.vue?vue&type=script&lang=js"
export * from "./addSchemaAcquiringSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports